var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "22px",
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "28BC4F84-C25A-4170-9170-D175AEA695EF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RiseIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Job-Details",
    transform: "translate(-1637.000000, -562.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 1680,
    height: 1066
  }), /*#__PURE__*/React.createElement("g", {
    id: "Row-Cadidates-2",
    transform: "translate(1236.000000, 542.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 444,
    height: 145
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(18.000000, 20.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Star-Off",
    transform: "translate(401.000000, 20.000000)",
    fill: "#EBEBEB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7773192,17.1880437 L17.8356808,21.2265337 C18.0654525,21.379699 18.3758842,21.3175972 18.5290495,21.0878256 C18.6119559,20.963453 18.6348713,20.8085116 18.5915153,20.6654652 L16.5520007,13.9364073 C16.4945595,13.7468891 16.5543828,13.5413283 16.7045496,13.4122292 L21.977384,8.87914792 C22.1867816,8.69912778 22.2105968,8.38344231 22.0305766,8.1740447 C21.9355901,8.06355733 21.7971336,8 21.6514287,8 L15.3270078,8 C15.1283589,8 14.9485513,7.88240308 14.8689291,7.70040942 L11.9580787,1.04703695 C11.8473956,0.794047092 11.5525804,0.678684639 11.2995906,0.789367704 C11.1843463,0.839787093 11.0923407,0.931792636 11.0419213,1.04703695 L8.13107088,7.70040942 C8.05144865,7.88240308 7.87164113,8 7.67299221,8 L1.3381973,8 C1.06205493,8 0.838197301,8.22385763 0.838197301,8.5 C0.838197301,8.64482338 0.900990958,8.78253217 1.01033184,8.87749734 L6.23337752,13.4138373 C6.38121268,13.5422356 6.44049325,13.7451123 6.3850502,13.9329086 L4.39378926,20.6776922 C4.31560014,20.9425337 4.46691186,21.2206151 4.73175346,21.2988042 C4.87389204,21.3407678 5.02732259,21.3175128 5.15064239,21.2353146 L11.222674,17.1880336 C11.3906131,17.0760946 11.6093842,17.0760986 11.7773192,17.1880437 Z",
    id: "Path-4"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarInactive);
export default __webpack_public_path__ + "static/media/star-inactive.34393f46accc5b40a8949b6c7c7ab00e.svg";
export { ForwardRef as ReactComponent };